import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/dashboard/forms/$type/$id')({
  component: FormDetailLayoutRoute,
});

function FormDetailLayoutRoute() {
  return <Outlet />;
}
